'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */
///* global */

var domUtils = require('./utils');
var domQuery = require('./query');

var queryOne = domQuery.one;

/*
 * @author: 绝云（wensen.lws）
 * @description: dom dataSet related
 * @note: if DataSet is supported, use DataSet
 */

var dataSetStr = 'dataset';
var dataPrefix = 'data-';

function toDashed(name) {
    return name.replace(/([A-Z])/g, function (u) {
        return '-' + u.toLowerCase();
    });
}

var dataset = domUtils.hasDataSet ? {
    set: function set(node, attr, value) {
        node = queryOne(node);
        node[dataSetStr][attr] = value;
    },
    get: function get(node, attr) {
        node = queryOne(node);
        return node[dataSetStr][attr];
    },
    remove: function remove(node, attr) {
        node = queryOne(node);
        delete node[dataSetStr][attr];
    }
} : {
    set: function set(node, attr, value) {
        node = queryOne(node);
        node.setAttribute(dataPrefix + toDashed(attr), value);
    },
    get: function get(node, attr) {
        node = queryOne(node);
        return node.getAttribute(dataPrefix + toDashed(attr));
    },
    remove: function remove(node, attr) {
        node = queryOne(node);
        node.removeAttribute(dataPrefix + toDashed(attr));
    }

};

module.exports = dataset;


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-dom/data.js
 ** module id = 52
 ** module chunks = 0
 **/